import React from 'react';
import { Button, Spinner } from 'reactstrap';

class LoaderButton extends React.PureComponent {
  render() {
    const {
      className,
      color,
      disabled,
      id,
      loading,
      loadingColor,
      loadingText,
      outline,
      onClick,
      size,
      style,
      tabIndex,
      text,
    } = this.props;
    if (loading) {
      return (
        <Button
          id={id}
          color={loadingColor || color}
          className={className}
          style={style}
          tabIndex={tabIndex}
          outline={outline}
          disabled
        >
          <Spinner className="me-2" size={size} />
          {loadingText}
        </Button>
      );
    }
    return (
      <Button
        id={id}
        color={color}
        className={className}
        onClick={onClick}
        style={style}
        tabIndex={tabIndex}
        outline={outline}
        disabled={disabled}
      >
        {text}
      </Button>
    );
  }
}

LoaderButton.defaultProps = {
  id: null,
  text: 'Do Something',
  loading: false,
  loadingText: 'Loading',
  loadingColor: null,
  onClick: () => {},
  color: 'primary',
  className: '',
  size: 'sm',
  style: {},
  tabIndex: 1,
  outline: false,
};

export default LoaderButton;
